import { mapActions, mapState } from 'vuex'

export default {
  props: {
    badge: String,
    playerId: String,
    gained: Boolean
  },
  data () {
    return {
      isLoading: false,
      showDetails: false
    }
  },
  computed: {
    ...mapState(['user', 'badges', 'superBadges']),
    canEdit () {
      return this.user.isSuperAdmin || (this.user.isAdmin && !this.superBadges.find(b => b.id === this.badge))
    },
    badgeObj () {
      return [...this.badges, ...this.superBadges].find(b => b.id === this.badge)
    },
    badgeImageName () {
      return this.badgeObj ? this.badgeObj.image : null
    }
  },
  methods: {
    ...mapActions(['patchBadge']),
    changeBadge (badge, value) {
      this.isLoading = true
      return this.patchBadge({ playerId: this.playerId, badge, value }).then(() => {
        this.isLoading = false
      })
    }
  }
}
